export default function speakText({
  text = '',
	lang = 'es-CO',
	volume = 1,
	rate = 1,
	pitch = 1,
	onStart = null,
	onEnd = null,
	onError = null,
	autoStart = true,
	delayBeforeResolve = 0,
} = {}) {
	return new Promise((resolve, reject) => {
		const synth = window.speechSynthesis;
		if (!synth) {
			reject(new Error('speechSynthesis no supported'));
			return;
		}
		synth.cancel();
		if (text.length === 0) {
			resolve();
			return;
		}

		const voices = synth.getVoices();
		const spanishMaleVoices = voices.filter(voice =>
			voice.lang.startsWith('es') &&
			/male|masculino|Jorge|Carlos|Juan/i.test(voice.name)
		);
		console.log("Voces!!!!!")
		console.log(voices)
		console.log(spanishMaleVoices)

		const utterance = new SpeechSynthesisUtterance(text);
		utterance.lang = lang;
		utterance.volume = volume;
		utterance.rate = rate;
		utterance.pitch = pitch;
		utterance.autoStart = autoStart;

		utterance.voice = spanishMaleVoices[0] || voices.find(voice => voice.lang.startsWith('es'));

		utterance.onstart = () => {
			if (typeof onStart === 'function') {
				onStart();
			}
		}

		utterance.onend = () => {
			if (typeof onEnd === 'function')
				onEnd();
			setTimeout(() => {
				resolve('finish data');
			}, delayBeforeResolve);
		};

		utterance.onerror = (e) => {
			if (typeof onError === 'function')
				onError(e);
			reject(e);
		}

		if (autoStart) {
			synth.speak(utterance);
		}

	})
}